import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { IconWrapper } from '../../../common/IconWrapper';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import WebDealImagePlaceholder from '../image-placeholder/WebDealImagePlaceholder';
import styles from './webDealCard.module.scss';

export default function WebDealCard({ deal }) {
    const history = useHistory();

    const navigateToWebDeal = () => {
        history.push('web-deals/' + deal.id);
    };

    return (
        <div className={styles.webDealCard}>
            {deal.remainingStock < 100 && (
                <div className={styles.textRibbonWrapper}>
                    <span className={styles.textRibbon}>Ending Soon!</span>
                </div>
            )}
            <div className={styles.image}>
                {deal.imageUrl ? (
                    <img src={deal.imageUrl} alt={deal.description} />
                ) : (
                    <WebDealImagePlaceholder />
                )}
            </div>
            <div className={styles.description}> {deal.description} </div>
            <div className={styles.stock}>
                <span className={deal.remainingStock < 100 ? styles.low : ''}>
                    Remaining stock: {deal.remainingStock}
                </span>
            </div>
            <div className={styles.qty}>
                Order Quantity: {deal.orderedQuantity ? deal.orderedQuantity : '-'}
            </div>
            <div className={styles.qty}>
                Max Margin: {deal.por ? (deal.por + '%') : '-'}
            </div>
            <div className={styles.button}>
                <Button onClick={navigateToWebDeal} variant={'primary'}>
                    <IconWrapper icon={faShoppingCart} />
                    See Products
                </Button>
            </div>
        </div>
    );
}
